"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  cancel: {
    "id": "common.actions.cancel",
    "defaultMessage": "Cancel"
  },
  selectFile: {
    "id": "MediaUploader.selectFile",
    "defaultMessage": "Select an image or video from your library or using the camera on your device"
  },
  uploadingFile: {
    "id": "MediaUploader.uploadingFile",
    "defaultMessage": "Uploading file..."
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map